import React from "react";
import { Spinner } from "@blueprintjs/core";
import { base } from "../../fire";

import DialogCreateParticipant from "./DialogCreateParticipant";
import InProgressSession from "./InProgressSession";
import Participant from "../../services/Participant";
import Session from "../../services/Session";
import FadeIn from "react-fade-in";

class SessionAutonomous extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      participant: Participant.getBySessionId(this.props.session.id) || null,
      alertCreateParticipantOpened: true,
      sessionInstance: {},
      sessionInstanceLoading: true,
      personalDataFiled: false,
    };
  }

  handleCreateParticipant = (createParticipantInfos) => {
    const { session } = this.props;
    const { id, data, metadata } = session;
    const { interludes = [], sequences = [] } = data;
    const { author } = metadata;

    const participant = Participant.createForSession(
      id,
      createParticipantInfos,
      author
    );

    const initInstanceResults = {};

    sequences.forEach(
      (s) => (initInstanceResults[s.id] = { _fakeId: "_fakeResult" })
    );
    Session.createAutonomousSessionInstance(id, participant.id, {
      created: Date.now(),
      type: "AUTONOMOUS",
      currentStep: interludes.length === 0 ? "PERSONALDATA" : "INTERLUDES",
      currentSequence: 0,
      currentSequenceInterlude: 0,
      currentSequenceInterludeStep: 0,
      currentInterlude: 0,
      currentConclusion: 0,
      currentSequenceResource: 0,
      results: initInstanceResults,
      participants: [participant],
    })
      .then(() =>
        this.setState({ participant, alertCreateParticipantOpened: false })
      )
      .then(() => {
        this.instanceId = participant.id;
        this.syncSessionInstanceRef = base.syncState(
          `sessionInstances/${session.id}/${participant.id}`,
          {
            context: this,
            state: "sessionInstance",
            keepKeys: true,
            then: () => this.setState({ sessionInstanceLoading: false }),
          }
        );
      });
  };

  handleSwitchResource = (index) =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentSequenceResource: index,
      },
    });

  handleNextSequence = () => {
    if (this.isNextSequenceDisabled()) return;
    this.setState((prevState) => {
      ++prevState.sessionInstance.currentSequence;
      prevState.sessionInstance.currentSequenceResource = 0;
      return prevState;
    });
  };

  handlePrevSequence = () => {
    if (this.isPrevSequenceDisabled()) return;
    this.setState((prevState) => {
      --prevState.sessionInstance.currentSequence;
      prevState.sessionInstance.currentSequenceResource = 0;
      return prevState;
    });
  };

  handleFinishSequence = () =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentStep: "FEEDBACKS",
      },
    });

  handleFinishResults = () =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentStep: "FEEDBACKS",
      },
    });

  handleBackSequence = () =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentStep: "INTERLUDES",
      },
    });

  handleNextInterlude = () => {
    if (this.isNextInterludeDisabled()) return;
    this.setState((prevState) => {
      ++prevState.sessionInstance.currentInterlude;
      return prevState;
    });
  };

  handlePrevInterlude = () => {
    if (this.isPrevInterludeDisabled()) return;
    this.setState((prevState) => {
      --prevState.sessionInstance.currentInterlude;
      return prevState;
    });
  };

  handleNextConclusion = () => {
    if (this.isNextConclusionDisabled()) return;
    this.setState((prevState) => {
      ++prevState.sessionInstance.currentConclusion;
      return prevState;
    });
  };

  handlePrevConclusion = () => {
    if (this.isPrevConclusionDisabled()) return;
    this.setState((prevState) => {
      --prevState.sessionInstance.currentConclusion;
      return prevState;
    });
  };

  handleFinishInterlude = () =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentStep: "PERSONALDATA",
      },
    });

  isPrevInterludeDisabled = () =>
    this.state.sessionInstance.currentInterlude === 0;

  isNextInterludeDisabled = () =>
    this.state.sessionInstance.currentInterlude ===
    this.props.session.data.interludes.length - 1;

  isPrevSequenceDisabled = () =>
    this.state.sessionInstance.currentSequence === 0;

  isNextSequenceDisabled = () =>
    this.state.sessionInstance.currentSequence ===
    this.props.session.data.sequences.length - 1;

  isNextConclusionDisabled = () =>
    this.state.sessionInstance.currentConclusion ===
    this.props.session.data.conclusions.length - 1;

  isPrevConclusionDisabled = () =>
    this.state.sessionInstance.currentConclusion === 0;

  handleChangeAnswer = (question, answer) =>
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        personalQuestions: {
          ...this.state.sessionInstance.personalQuestions,
          [question]: answer,
        },
      },
    });

  finishPersonalData = () => {
    this.setState({
      personalDataFiled: true,
      sessionInstance: {
        ...this.state.sessionInstance,
        currentStep: "SEQUENCES",
      },
    });
  };

  onPrevSequenceInterlude = () => {
    let next = this.state.sessionInstance.currentSequenceInterlude - 1;
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentSequenceInterlude: next,
      },
    });
  };

  onNextSequenceInterlude = () => {
    let previous = this.state.sessionInstance.currentSequenceInterlude + 1;
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentSequenceInterlude: previous,
      },
    });
  };

  onFinishSequenceInterlude = () => {
    this.setState({
      sessionInstance: {
        ...this.state.sessionInstance,
        currentSequenceInterludeStep:
          this.state.sessionInstance.currentSequenceInterludeStep + 1,
        currentSequenceInterlude: 0,
      },
    });
  };

  render() {
    const { session } = this.props;
    const { chainedSession } = session.metadata;
    const { id, metadata } = session;
    const { author } = metadata;
    const { participant, sessionInstance, sessionInstanceLoading } = this.state;

    if (!participant && !session.metadata.shouldPromptUserName) {
      this.handleCreateParticipant("participant");
    }

    if (!participant && session.metadata.shouldPromptUserName)
      return (
        <DialogCreateParticipant
          isOpen={this.state.alertCreateParticipantOpened}
          onCreateParticipant={this.handleCreateParticipant}
          id={id}
          author={author}
        />
      );

    if (sessionInstanceLoading || participant == null)
      return <Spinner className="margin-top-large" />;

    return (
      <FadeIn>
        <InProgressSession
          instance={{ ...sessionInstance, id: this.instanceId }}
          session={session}
          onNextInterlude={this.handleNextInterlude}
          onPrevInterlude={this.handlePrevInterlude}
          onFinishInterlude={this.handleFinishInterlude}
          onSwitchResource={this.handleSwitchResource}
          onNextSequence={this.handleNextSequence}
          onPrevSequence={this.handlePrevSequence}
          onFinishSequence={this.handleFinishSequence}
          onFinishResults={this.handleFinishResults}
          onNextConclusion={this.handleNextConclusion}
          onPrevConclusion={this.handlePrevConclusion}
          onBackSequence={this.handleBackSequence}
          onPrevSequenceInterlude={this.onPrevSequenceInterlude}
          onNextSequenceInterlude={this.onNextSequenceInterlude}
          onFinishSequenceInterlude={this.onFinishSequenceInterlude}
          handleChangeAnswer={this.handleChangeAnswer}
          personalQuestions={session.metadata.personalQuestions}
          finishPersonalData={this.finishPersonalData}
          personalAnswers={sessionInstance.personalQuestions}
          chainedSession={chainedSession}
        />
      </FadeIn>
    );
  }

  componentDidMount() {
    const { session } = this.props;
    const { data } = session;
    const { sequencesResources = [], interludes = [], conclusions = [] } = data;
    const participant = Participant.getBySessionId(session.id) || null;
    // In autonomous, we shuffle the order of sequences to improve statistics results
    // this.props.session.data.sequences = _.shuffle(
    //   this.props.session.data.sequences
    // );
    if (participant == null) return;
    this.instanceId = participant.id;
    Session.getAutonomousSessionInstanceIdById(session.id, participant.id).then(
      (data) => {
        if (data == null)
          return this.setState({
            participant: Participant.deleteForSession(session.id),
          });
        this.syncSessionInstanceRef = base.syncState(
          `sessionInstances/${session.id}/${participant.id}`,
          {
            context: this,
            state: "sessionInstance",
            keepKeys: true,
            then: () => this.setState({ sessionInstanceLoading: false }),
            onFailure: (e) => console.error(e),
          }
        );
      }
    );
    sequencesResources.forEach((resource) => {
      const image = new Image();

      image.onload = () =>
        console.log(`Image preloaded (${resource.downloadURL})`);
      image.onerror = () =>
        console.error(`IPreloading failed (${resource.downloadURL})`);
      image.src = resource.downloadURL;
    });

    interludes.forEach((interlude) => {
      const image = new Image();

      image.onload = () =>
        console.log(`Image preloaded (${interlude.downloadURL})`);
      image.onerror = () =>
        console.error(`Preloading failed (${interlude.downloadURL})`);
      image.src = interlude.downloadURL;
    });

    conclusions.forEach((conclusion) => {
      const image = new Image();

      image.onload = () =>
        console.log(`Image preloaded (${conclusion.downloadURL})`);
      image.onerror = () =>
        console.error(`Preloading failed (${conclusion.downloadURL})`);
      image.src = conclusion.downloadURL;
    });
    document.body.style.padding = "0";
  }
  componentWillUnmount() {
    if (this.syncSessionInstanceRef)
      base.removeBinding(this.syncSessionInstanceRef);
    document.body.style.padding = null;
  }
}

export default SessionAutonomous;
